import React, { useEffect, useState } from "react";
import { Grid, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import BackBtn from "../../../../library/custom/backBtn/backBtn";
import ViewImages from "../../../case/common/viewImages/viewImages";
import "./viewPermit.scss";
import File from "../../../../library/custom/media/File";

export default function ViewPermit({
  permitDetails,
  getPermitType,
  projectName,
  dataBack,
  stateId,
  componentRef,
}) {
  const imageSize = {
    size: "small",
  };
  const imageSizeSignature = {
    size: "small",
  };
  const [image, setImage] = useState([]);
  const [signatureImage, setSignatureImage] = useState([]);
  useEffect(() => {
    setImage(permitDetails?.documentUrl);
    setSignatureImage(permitDetails?.signatureUrl);
  }, [permitDetails]);

  var permidatatype = getPermitType?.permitType?.filter(
    (val) => val?.key == permitDetails?.permitteeTypeId
  );
  return (
    <>
      <div className="viewOverideClient viewPermit">
        <Grid container className="topHeaderPermit">
          <Grid item xs={6} md={6}>
            <BackBtn dataBack={dataBack} />
          </Grid>
        </Grid>
      </div>

      <div className="viewOverideContact viewPermitInner">
        <div className="commonOveride permitPdf">
          {/* <Typography className="titleDetail">{projectName}</Typography> */}
          <Box className="commoninfoWrap permitWrapper" ref={componentRef}>
            <Box className="commoninfoBox">
              <Box className="commoninfoleft widthIncr">
                <Typography className="title">Details:</Typography>
                <Box className="columns">
                  <Typography className="listView">
                    Permittee ID :
                    <span className="font-w400">{permitDetails?.permitId}</span>
                  </Typography>
                  <Typography className="listView">
                    Permit Type :
                    <span className="font-w400">
                      {permidatatype && permidatatype[0]?.value}
                    </span>
                  </Typography>
                </Box>
                <Box className="columns">
                  <Typography className="listView">
                    Permit Enforcement :
                    <span className="font-w400">
                      {permitDetails?.holderName}
                    </span>
                  </Typography>
                  <Typography className="listView">
                    Permittee Address :
                    <span className="font-w400">{permitDetails?.address}</span>
                  </Typography>
                </Box>
                <Box className="columns">
                  <Typography className="listView">
                    Permit Number :
                    <span className="font-w400">
                      {permitDetails?.permitNumber}
                    </span>
                  </Typography>

                  <Typography className="listView">
                    Project Name :
                    <span className="font-w400">{projectName}</span>
                  </Typography>
                </Box>
                <Box className="columns">
                  <Typography className="listView">
                    State:
                    <span className="font-w400"> {permitDetails?.state}</span>
                  </Typography>
                  <Typography className="listView">
                    Permit Approval Date :
                    <span className="font-w400">
                      {permitDetails?.approvalDate}
                    </span>
                  </Typography>
                </Box>
                <Box className="columns">
                  <Typography className="listView">
                    Permit Expiration Date:
                    <span className="font-w400">
                      {permitDetails?.expirationDate}
                    </span>
                  </Typography>
                  <Typography className="listView">
                    General Permit Expiration Date:
                    <span className="font-w400">
                      {permitDetails?.sitePermitExpirationDate}
                    </span>
                  </Typography>
                </Box>
                <Box>
                  <Typography className="listView ">
                    Permit :
                    <span className="blockView permitFileUpload">
                      <File
                        removeIcon={false}
                        handleCloseFile={false}
                        files={image?.length > 0 ? [image] : []}
                        imageUrl={image?.length > 0 ? [image] : []}
                      />
                    </span>
                  </Typography>
                </Box>
                {stateId === 3 &&
                permidatatype &&
                (permidatatype[0]?.value === "primary" ||
                  permidatatype[0]?.value === "Primary") ? (
                  <Box>
                    <Typography className="listView permitFileUpload">
                      <>
                        <File
                          removeIcon={false}
                          handleCloseFile={false}
                          files={
                            signatureImage?.length > 0 ? [signatureImage] : []
                          }
                          imageUrl={
                            signatureImage?.length > 0 ? [signatureImage] : []
                          }
                        />
                      </>
                    </Typography>
                  </Box>
                ) : (
                  ""
                )}
              </Box>
            </Box>
          </Box>
        </div>
      </div>
    </>
  );
}
